import React, { useState } from "react";
import { Button, Input, message, Modal, Select, Table } from "antd";
import { ModalProps } from "antd/es/modal";
import Space from "components/Space";
import useRequest from "utils/useRequest";
import { getCourseInfo } from "service/group";

import styles from "./index.module.scss";
import { ColumnProps } from "antd/lib/table/interface";
import useRequestFn from "utils/useRequestFn";
import Form from "rc-field-form";
import { filterOption } from "utils/common";
import {
    copyDiscuss,
    DiscussListItem,
    queryAllDiscuss,
    QueryAllDiscussForm
} from "service/discuss";
import { errorMessage, isTrue } from "service/service";
import moment from "moment";
import { useMount } from "react-use";

interface CopyModalProps extends ModalProps {
    courseNo: string;
    courseSeq: string;
    batchNo: string;
    weekTimeId: number;
    onOk(): void;
}

export default function CopyModal({
    courseNo,
    courseSeq,
    batchNo,
    weekTimeId,
    onOk,
    ...props
}: CopyModalProps) {
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[] | number[]>(
        []
    );

    const [courseInfo, courseListStatus] = useRequest(getCourseInfo);

    const [queryData, { loading, data }] = useRequestFn(
        async (query: QueryAllDiscussForm) => {
            const { course, ...restQuery } = query;
            setSelectedRowKeys([]);

            if (course) {
                const [courseNo, courseSeq] = course.split("-");
                return queryAllDiscuss({ ...query, courseNo, courseSeq });
            } else {
                return queryAllDiscuss(restQuery);
            }
        }
    );

    useMount(() => queryData({}));

    const [onCopy, copyStatus] = useRequestFn(async () => {
        try {
            await copyDiscuss(selectedRowKeys, {
                courseNo,
                courseSeq,
                batchNo,
                weekTimeId
            });
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const columns: ColumnProps<DiscussListItem>[] = [
        { title: "序号", width: 60, render: (_, item, index) => index + 1 },
        { title: "讨论标题", dataIndex: "topicName" },
        {
            title: "课程信息",
            render: (_, item) =>
                `[${item.courseNo}-${item.courseSeq}] ${item.courseName}`
        },
        {
            title: "状态",
            dataIndex: "isStart",
            width: 80,
            align: "center",
            render: isStart => (isTrue(isStart) ? "进行中" : "未开始") // todo, 状态缺少已结束
        },
        {
            title: "创建时间",
            dataIndex: "createTime",
            width: 180,
            align: "center",
            render: createTime =>
                moment(createTime).format("YYYY-MM-DD HH:mm:ss")
        } // 缺少创建时间
    ];

    return (
        <Modal
            title="复制讨论"
            width={1000}
            {...props}
            onOk={onCopy}
            okButtonProps={{ disabled: selectedRowKeys.length === 0 }}
            confirmLoading={copyStatus.loading}>
            <Form onFinish={queryData}>
                <Space className={styles.header}>
                    <Space size={15}>
                        课程信息
                        <Form.Field name="course">
                            <Select
                                className={styles.select}
                                placeholder="请选择课程"
                                showSearch
                                allowClear
                                filterOption={filterOption}
                                dropdownMatchSelectWidth={false}
                                loading={courseListStatus.loading}>
                                {courseInfo?.map(item => (
                                    <Select.Option
                                        value={`${item.courseno}-${item.courseseq}`}
                                        key={item.id}>
                                        [{item.courseno} - {item.courseseq}
                                        ]&nbsp;
                                        {item.coursename}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Field>
                    </Space>

                    <Space.Spacer />

                    <Space>
                        <Form.Field name="keyword">
                            <Input
                                placeholder="请输入主题名或关键字"
                                allowClear
                            />
                        </Form.Field>

                        <Button type="primary" icon="search" htmlType="submit">
                            查询
                        </Button>
                    </Space>
                </Space>
            </Form>

            <Table
                rowKey="uuid"
                columns={columns}
                rowSelection={{
                    selectedRowKeys,
                    onChange: selectedRowKeys =>
                        setSelectedRowKeys(selectedRowKeys)
                }}
                dataSource={data || []}
                pagination={false}
                loading={loading}
                scroll={{ y: 400 }}
            />
        </Modal>
    );
}
